import { LISTING_ATTRIBUTE_NAME, LISTING_ATTRIBUTE_VALUE } from '@/constants/listingAttributes'
import { type Listing } from '@/types/search'

/**
 * Checks if listing is a dealer listing based on its attributes
 */
export const isDealerListing = (listing: Listing): boolean =>
  listing.attributes.find((attribute) => attribute.name === LISTING_ATTRIBUTE_NAME.FOR_SALE_BY)
    ?.values[0] === LISTING_ATTRIBUTE_VALUE.DEALER
